import React from "react";
import "../../../features/dashboard/contractDashboard.css";

interface HexagonAvatarProps {
  imageUrl: string;
  size?: number;
}

const HexagonAvatar: React.FC<HexagonAvatarProps> = ({ imageUrl, size = 80, ...props }) => {
  console.log(imageUrl);
  return (
    <div className="hexagon" style={{ width: size, height: size }} {...props}>
      <img src={imageUrl} alt="Profile" />
    </div>
  );
};

export default HexagonAvatar;
